import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '../../../../components/_molecules/Modal/Modal';
import './PasswordModal.scss';
import PasswordFormContext from './PasswordFormContext';
import {
  TEXT_FIELD_STATUS,
  CONTEXT_PROVIDERS,
  SUCCESS,
  ERROR,
} from '../../../../utils/constants';
import PasswordField from '../../../../components/_molecules/PasswordField/PasswordField';
import { getFieldInitialState } from '../../../../utils/helpers';
import Button from '../../../../components/_atomic/Button/Button';
import ErrorModal from '../../../../components/_molecules/ErrorModal/ErrorModal';

const oldPasswordFieldName = 'oldPassword';
const newPasswordFieldName = 'newPassword';
const repeatPasswordFieldName = 'repeatPassword';

class PasswordModal extends Component {
  static propTypes = {
    isVisible: PropTypes.bool.isRequired,
    changePassword: PropTypes.func.isRequired,
    changePasswordStatus: PropTypes.string.isRequired,
    changePasswordError: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
    resetChangePasswordStatus: PropTypes.func.isRequired,
    havePassword: PropTypes.bool.isRequired,
  };
  constructor() {
    super();
    this.fields = {};
  }
  state = {
    fields: {
      [oldPasswordFieldName]: getFieldInitialState(),
      [newPasswordFieldName]: getFieldInitialState(),
      [repeatPasswordFieldName]: getFieldInitialState(),
    },
  };

  componentWillMount() {
    const fields = { ...this.state.fields };
    const { havePassword } = this.props;
    if (!havePassword) {
      fields[oldPasswordFieldName] = getFieldInitialState(TEXT_FIELD_STATUS.VALID, undefined, null);
    }
    this.setState(() => ({ fields }));
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
       then form isn't valid or invalid it is initial */

    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) validFields += 1;
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].value = value;

    if (name === oldPasswordFieldName) {
      if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
        const { validator } = this.fields[name];
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
    }

    if (name === newPasswordFieldName) {
      if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
        const { validator } = this.fields[name];

        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
    }
    if (fields[repeatPasswordFieldName].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[repeatPasswordFieldName];
      const validate = validator(
        fields[repeatPasswordFieldName].value,
        fields[newPasswordFieldName].value,
      );
      fields[repeatPasswordFieldName].status = validate.status;
      fields[repeatPasswordFieldName].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    fields[name].value = value;
    if (!isFocused) {
      const { validator } = this.fields[name];
      if (name === oldPasswordFieldName) {
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }

      if (name === newPasswordFieldName) {
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
      if (name === repeatPasswordFieldName) {
        const validate = validator(
          fields[repeatPasswordFieldName].value,
          fields[newPasswordFieldName].value,
        );
        fields[repeatPasswordFieldName].status = validate.status;
        fields[repeatPasswordFieldName].errorText = validate.errorText;
        formStatus = this.getFormStatus(fields);
      }
    }
    this.setState(() => ({ fields, formStatus }));
  };
  closeModal = () => {
    const fields = {
      [oldPasswordFieldName]: getFieldInitialState(),
      [newPasswordFieldName]: getFieldInitialState(),
      [repeatPasswordFieldName]: getFieldInitialState(),
    };
    this.setState(
      () => ({
        fields,
      }),
      () => {
        this.props.closeModal();
        this.props.resetChangePasswordStatus();
      },
    );
  };
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  submitHandler = (e) => {
    e.preventDefault();
    const { havePassword } = this.props;
    const fields = { ...this.state.fields };

    let oldPasswordValidate = { status: TEXT_FIELD_STATUS.VALID, errorText: '' };
    if (havePassword) {
      const { validator: oldPasswordValidator } = this.fields[
        oldPasswordFieldName
      ];
      oldPasswordValidate = oldPasswordValidator(fields[oldPasswordFieldName].value);
    }

    fields[oldPasswordFieldName].status = oldPasswordValidate.status;
    fields[oldPasswordFieldName].errorText = oldPasswordValidate.errorText;
    const { validator } = this.fields[newPasswordFieldName];
    const validate = validator(fields[newPasswordFieldName].value);
    fields[newPasswordFieldName].status = validate.status;
    fields[newPasswordFieldName].errorText = validate.errorText;
    const confirmValidator = this.fields[repeatPasswordFieldName].validator;
    const confirmValidate = confirmValidator(
      fields[repeatPasswordFieldName].value,
      fields[newPasswordFieldName].value,
    );
    fields[repeatPasswordFieldName].status = confirmValidate.status;
    fields[repeatPasswordFieldName].errorText = confirmValidate.errorText;

    const formStatus = this.getFormStatus(fields);
    this.setState(
      () => ({ fields, formStatus }),
      () => {
        if (formStatus === TEXT_FIELD_STATUS.VALID) {
          const data = {
            oldPassword: fields[oldPasswordFieldName].value,
            newPassword: fields[newPasswordFieldName].value,
          };
          this.props.changePassword(data);
        }
      },
    );
  };

  render() {
    const {
      isVisible,
      changePasswordStatus,
      changePasswordError,
      resetChangePasswordStatus,
      havePassword,
    } = this.props;
    const { fields, formStatus } = this.state;
    const oldPasswordField = fields[oldPasswordFieldName];
    const newPasswordField = fields[newPasswordFieldName];
    const repeatPasswordField = fields[repeatPasswordFieldName];
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    const passwordModalClasses = classNames({
      'password-modal-content-wrapper': true,
      success: changePasswordStatus === SUCCESS,
    });
    return (
      <Modal
        requestClose={this.closeModal}
        visible={isVisible}
        className="password-modal"
      >
        <ErrorModal
          visible={changePasswordStatus === ERROR}
          requestClose={resetChangePasswordStatus}
          error={changePasswordError}
        />
        <div className={passwordModalClasses}>
          <div className="password-modal-content">
            <div className="form-content">
              <div className="main-label-no-transform">
                <span>Change Password</span>
              </div>
              <div className="plain-text">
                <span>
                  Should be at least 6 symbols, contain uppercase, lowercase and
                  one number
                </span>
              </div>

              <div className="password-form-wrapper">
                <form className="password-form" onSubmit={this.submitHandler}>
                  <PasswordFormContext.Provider
                    value={{
                      register: this.registerField,
                      changeHandler: this.fieldChangeHandler,
                      focusHandler: this.fieldFocusHandler,
                    }}
                  >
                    {havePassword &&
                    <PasswordField
                      name={oldPasswordFieldName}
                      value={oldPasswordField.value}
                      status={oldPasswordField.status}
                      isFocused={oldPasswordField.isFocused}
                      errorText={oldPasswordField.errorText}
                      isRequired
                      placeholder="Old Password"
                      label="Old Password"
                      contextProvider={CONTEXT_PROVIDERS.PasswordFormContext}
                    />
                  }
                    <PasswordField
                      name={newPasswordFieldName}
                      value={newPasswordField.value}
                      status={newPasswordField.status}
                      isFocused={newPasswordField.isFocused}
                      errorText={newPasswordField.errorText}
                      needSpecifiedValidator
                      needConfirmation
                      isRequired
                      placeholder="New Password"
                      label="New Password"
                      contextProvider={CONTEXT_PROVIDERS.PasswordFormContext}
                    />

                    <PasswordField
                      name={repeatPasswordFieldName}
                      value={repeatPasswordField.value}
                      status={repeatPasswordField.status}
                      isFocused={repeatPasswordField.isFocused}
                      errorText={repeatPasswordField.errorText}
                      needConfirmation
                      isRequired
                      placeholder="Repeat New Password"
                      label="Repeat New Password"
                      contextProvider={CONTEXT_PROVIDERS.PasswordFormContext}
                    />
                  </PasswordFormContext.Provider>
                  <div className="button-wrapper">
                    <Button
                      label="Save"
                      type="submit"
                      disabled={disabledButton}
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="success-content">
              <div className="main-label-no-transform">
                <span>Success</span>
              </div>
              <div className="plain-text">
                <span>Your Password has been changed!</span>
              </div>
              <div className="button-wrapper">
                <Button label="OK" clickHandler={this.closeModal} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default PasswordModal;



// WEBPACK FOOTER //
// ./src/containers/UserScreen/components/PasswordModal/PasswordModal.js